import React, { memo } from 'react';
import { Box, InputAdornment, Tooltip } from '@mui/material';
import { FastField } from 'formik';
import { LanguageCodeEnum } from '../common/enums/common.enum';
import GenericTextField from './GenericTextField/GenericTextField';
import { ReactComponent as WarningTriangleIcon } from '../assets/warning-triangle-icon.svg';
import { useTranslation } from 'react-i18next';

import { palette } from '../theme';
interface FastItemFieldProps {
  index: number;
  fieldName: string;
  lang: LanguageCodeEnum;
}

const FastItemField: React.FC<FastItemFieldProps> = memo(({ index, fieldName, lang }) => {
  const { t } = useTranslation();
  const titleFieldName = `${fieldName}[${index}].title.${lang}`;

  return (
    <Box display="flex" alignItems="center" gap={1.5}>
      <FastField name={titleFieldName}>
        {({ field, meta }: any) => {
          const fieldValue = field.value;
          const highlightError = lang === LanguageCodeEnum.ENG && meta.touched && !!meta.error;
          const showWarning = lang !== LanguageCodeEnum.ENG && !fieldValue;

          return (
            <GenericTextField
              label=""
              size="small"
              {...field}
              error={highlightError}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: showWarning ? palette.warning.border : undefined
                  },
                  '&:hover fieldset': {
                    borderColor: showWarning ? palette.warning.border : undefined
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: showWarning ? palette.warning.border : undefined
                  }
                }
              }}
              InputProps={{
                endAdornment: showWarning ? (
                  <InputAdornment position="end">
                    <Box sx={{ pr: 1, display: 'flex', alignItems: 'center' }}>
                      <Tooltip title={t('events.emptyTranslationFallsBack')}
                      >
                        <WarningTriangleIcon style={{ width: 24, height: 24, cursor: 'auto'  }} />
                      </Tooltip>
                    </Box>
                  </InputAdornment>
                ) : undefined
              }}
            />
          );
        }}
      </FastField>
    </Box>
  );
});

export default FastItemField;
